const states = {
  soldoutWaitlistEnabled: 'soldoutWaitlistEnabled',
  soldoutWaitlistNotEnabled: 'soldoutWaitlistNotEnabled',
  salesEnded: 'salesEnded',
  unavailableAllHidden: 'unavailableAllHidden',
  unavailableOnlyAtDoor: 'unavailableOnlyAtDoor',
  unavailableGeofenced: 'unavailableGeofenced',
  semiAvailableAllLocked: 'semiAvailableAllLocked',
  semiAvailableNotStarted: 'semiAvailableNotStarted',
  salesEndedEventOver: 'salesEndedEventOver',
  availableStandard: 'availableStandard',
  noData: 'noData',
  noIdea: 'noIdea',
}

const eventStateModel = (eventData) => {
  if (!eventData) return states.noData

  const currentTime = new Date().getTime() / 1000

  // "regular" here means not locked, not soldAtDoor, not hidden etc.
  const ticketsSoldOut = eventData.soldOut
  const hasRegularRatesAvailable = eventData.rates?.nodes.length !== 0
  const hasOngoingOrFutureTimeSlots = eventData.availableTimeSlots.totalCount !== 0
  const allTicketsLocked = !hasRegularRatesAvailable && eventData.rateStateExists?.locked
  const allTicketsAtDoor = !hasRegularRatesAvailable && eventData.rateStateExists?.soldAtDoor
  const allTicketsHidden = !hasRegularRatesAvailable && eventData.rateStateExists?.inactive
  const eventGeofenced = SSR_DATA.countryCode && eventData.availableCountries?.length &&
    !eventData.availableCountries?.includes(SSR_DATA.countryCode.toUpperCase())
  const { allowWaitlist } = eventData

  // TODO: move this to backend with
  const ticketSalesStarted = !!(hasOngoingOrFutureTimeSlots && eventData.rates?.nodes.some(rate => (
    (!rate.startStamp || rate.startStamp <= currentTime)
  )))

  // TODO: verify this works with timezones
  const ticketSalesEnded = !!(hasRegularRatesAvailable && eventData.rates?.nodes.every(rate => (
    (rate.endStamp && (rate.endStamp <= currentTime))
  )))

  // note - there will soon be a "draft" type state where we will say smth like "ticket coming soon"
  if (eventGeofenced) return states.unavailableGeofenced
  if (eventData.state === 'EXPIRED' || !hasOngoingOrFutureTimeSlots) return states.salesEndedEventOver
  if (ticketSalesEnded) return states.salesEnded
  if (ticketsSoldOut && allowWaitlist) return states.soldoutWaitlistEnabled
  if (ticketsSoldOut && !allowWaitlist) return states.soldoutWaitlistNotEnabled
  if (allTicketsLocked) return states.semiAvailableAllLocked
  if (allTicketsHidden) return states.unavailableAllHidden
  if (allTicketsAtDoor) return states.unavailableOnlyAtDoor
  if (!ticketSalesStarted) return states.semiAvailableNotStarted

  return states.availableStandard
}

export default eventStateModel
